<template>
    <div>
    
        <not-allowed v-if="!AllowedDisplay" :page="page" :module="idmodule" :data="datas"></not-allowed>
    <v-scale-transition>

    <div v-show="show">

        <v-btn @click="recharge">recharger</v-btn> 
        <v-btn @click="downloadFile">Telecharger</v-btn>
        <v-btn v-if="saveged" @click="saveGed">Sauvegarder dans la GED</v-btn>
        <br>
            <iframe ref="monIframe" width="100%" height="600" :src="pdfUrl" v-if="typePage=='edit' || customparams">
            </iframe>
            <div v-if="typePage=='new'">Veuillez enregistrer le formulaire avant de voir le PDF</div>

    
        </div>
    
    </v-scale-transition>
    </div>
    </template>
    
    
    
    <script>
const token = localStorage.getItem("tokenMinu");
import api from '../../services/api'   
        export default {
        props: ['idmodule','page','modal','parent','customparams','customquerys'],
    
            data: function() {
    
                return {
                    AllowedDisplay : true,
                    show : false,
                    pdfUrl : '',
                    datas : [],
                    displays : [],
                    saveged : false,
                    params:{},
                    querys:{},
                          // permet de définir si ce module est intégré dans une page form (nouvelle:newform ou en mode édition:editform), ou une page classique : page
                    typePage : (!this.$store.getters['listForm'](this.page)) ? 'page' : this.$store.getters['listForm'](this.page).typeform ,
                }
            },

        computed : {
            modEditForm() {
                return this.$store.getters['listForm'](this.page);
            }
        },

        watch : {
            
            'modEditForm.typeform': {
                // permet de rafraichir quand la modal de modif du module de la page se ferme
                handler(newVal,oldVal) {
                    if(oldVal!='new') return;
                        this.typePage = newVal
                        this.initiateParams()
                        this.getPDF()
                },deep:true,
            },

        },

            methods :  {    
    
                getPDF : function() {
                    if(this.typePage=='new') return
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.querys}}).then((resp) => {
                        this.datas = resp.data
                            if(!resp.data.success) {
                            this.AllowedDisplay = false; 
                            return false;
                            }
                            this.saveged = resp.data.saveged;
                            this.displays = resp.data.displays
                            this.pdfUrl = api.defaults.baseURL+'pdf?token='+token+'&id='+this.idmodule+'&params='+JSON.stringify(this.params);
                            this.show = true 
                            
                    })
    
                },

                saveGed() {
                    this.$store.dispatch('textOverlay','Transfert du document en cours');
                    this.$store.dispatch('getoverlay', true)
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,saveged:true,params:this.params,querys:this.querys}}).then((resp) => {
                        this.$store.dispatch('getoverlay', false)
                        if(!resp.data.success) {
                            this.$toast.error(resp.data.message)
                            return false;
                            }       
                            this.$toast.success(resp.data.message)                                     
                    })
                },
                recharge() {
                // Changez l'URL de l'iframe pour provoquer son rechargement
                this.pdfUrl = ''; // Assurez-vous de vider d'abord l'URL
                    setTimeout(() => {
                        this.pdfUrl = api.defaults.baseURL+'pdf?token='+token+'&id='+this.idmodule+'&params='+JSON.stringify(this.params)+'&rebuild=ok'; // Remettez l'URL d'origine
                    },500);
                },
    

                downloadFile() {
                    
                    this.API({type:'get',url:'/pdf?token='+token+'&id='+this.idmodule+'&params='+JSON.stringify(this.params),apidefault:{responseType:'blob',headers:{'Accept':'application/pdf'}}}).then((resp) => {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        var name = (this.datas.displays.params.documentname) ? this.datas.displays.params.documentname : 'mon_pdf'
                        link.setAttribute('download', name+'.pdf');
                        document.body.appendChild(link);
                        link.click();
                    })
                    

                },      

                initiateParams() {
                var modal = this.$store.getters.modalShowParams({ type: 'to', val: this.page })
                this.params = (this.modal && modal.show) ? modal.params : this.$route.params
                this.querys = (this.modal && modal.show) ? modal.query : this.$route.query
                this.params = (this.customparams) ? this.customparams : this.params
                this.querys = (this.customquerys) ? this.customquerys : this.querys
                }
                
            },
            mounted() {
                this.initiateParams()
                this.getPDF()
                if(this.querys.download == this.idmodule) {
                    this.downloadFile()
                }
            },
    
            created() {  

            }
    
        }
    
    </script>
    